module.exports = __webpack_public_path__ + "img/rocket.b9d4f8ca.svg";